import TaxonomyTerm from "../../types/TaxonomyTerm";
import { TaxonomyAction, TaxonomyState } from "./TaxonomyState";

export const DISPATCH = 'WIS/taxonomy/medical_status/DISPATCHED';
export const FULFILL = 'WIS/taxonomy/medical_status/FULFILLED';
export const REJECT = 'WIS/taxonomy/medical_status/REJECTED';

export type MedicalStatusActionTypes = 
  'WIS/taxonomy/medical_status/DISPATCHED'
  | 'WIS/taxonomy/medical_status/FULFILLED'
  | 'WIS/taxonomy/medical_status/REJECTED';

export const dispatch = () => ({ type: DISPATCH });
export const fulfill = (payload: TaxonomyTerm[]) => ({ type: FULFILL, payload });
export const reject = (error: string) => ({ type: REJECT, error });

const initialState: TaxonomyState = {
  terms: [],
  isFetching: false,
  isFetched: false,
  error: null,
};

export type TaxonomyMedicalStatusAction = TaxonomyAction<MedicalStatusActionTypes>;

export default function reducer(state = initialState, action: TaxonomyMedicalStatusAction) {
  switch (action.type) {
    case DISPATCH:
      return {
        ...state,
        isFetching: true,
      };

    case FULFILL:
      return {
        ...state,
        terms: action.payload,
        isFetching: false,
        isFetched: true,
        error: null,
      };

    case REJECT:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };

    default:
      return state;
  }
}
